/* Require an explicit size choice before adding to cart.

   The theme always resolves to the first available variant (so it never renders "no selection"),
   which means a shopper can hit Add to Cart without choosing and get the smallest size. This
   deselects the size buttons on load, disables the buy actions with a "Select your size" prompt,
   and only re-enables once the shopper picks a size. It doesn't touch the variant machinery — the
   theme re-enables/labels the button on selection; we just gate until then.

   Scope: the main product form, and only when there's a real Size option (2+ values). Colour-only
   or single-variant products are untouched. */
(function () {
  // Mirrors the theme's [disabled] button look (opacity .6, no fill) but stays clickable,
  // so a gated sticky button can scroll the shopper up to the size picker.
  const style = document.createElement('style');
  style.textContent =
    '.button.size-gate-look-disabled{opacity:.6}' +
    '.button.size-gate-look-disabled .btn-fill{display:none}';
  document.head.appendChild(style);

  function labelSpan(btn) {
    return btn.querySelector('.btn-text > span') || btn.querySelector('.btn-text') || btn;
  }

  function gate(form) {
    if (!form || form.__sizeGateInit) return;
    const id = form.getAttribute('id');
    if (!id || id.indexOf('ProductForm-') !== 0) return;
    const suffix = id.slice('ProductForm-'.length);
    const scope = form.closest('.shopify-section') || document;
    // Radio name is "{Option name}-{section}-{product}". Find the "Size" group,
    // matching the option name case-insensitively ("Size" and "SIZE" both occur).
    const tail = '-' + suffix;
    const groups = {};
    Array.prototype.forEach.call(
      scope.querySelectorAll('input[type="radio"][name$="' + tail + '"]'),
      function (r) {
        const opt = r.name.slice(0, r.name.length - tail.length).toLowerCase();
        if (opt === 'size') (groups.size = groups.size || []).push(r);
      }
    );
    const radios = groups.size || [];
    if (radios.length < 2) return; // no size choice to make
    form.__sizeGateInit = true;

    const addButtons = Array.prototype.slice.call(
      document.querySelectorAll('[name="add"][form="' + id + '"]')
    );
    const dynamicWraps = Array.prototype.slice.call(scope.querySelectorAll('.shopify-payment-button'));
    // The sticky buy bar prints the resolved variant title ("8 US") even with nothing chosen.
    // Blank it while gated; the theme repopulates it on the first real selection.
    const stickyOptions = scope.querySelector('[data-sticky-product-options]');

    // The sticky bar sits off-screen from the picker, so its gated button stays clickable and
    // scrolls back up to the size options instead of being a dead disabled control. The main
    // button is right beside the picker, so it just disables.
    const stickyBtn = addButtons.filter(function (b) { return b.closest('product-sticky-form'); });

    function scrollToPicker() {
      const fs = radios[0].closest('fieldset') || radios[0].closest('variant-picker') || radios[0];
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // Remember each button's real label so we can restore it (the theme also resets it on select).
    addButtons.forEach(function (b) {
      const ls = labelSpan(b);
      if (ls && b.__origLabel == null) b.__origLabel = ls.textContent;
    });

    function setGated(on) {
      form.__sizeGated = on;
      addButtons.forEach(function (b) {
        const ls = labelSpan(b);
        const isSticky = stickyBtn.indexOf(b) !== -1;
        if (on) {
          if (isSticky) b.classList.add('size-gate-look-disabled');   // clickable, looks disabled
          else b.setAttribute('disabled', '');
          if (ls) ls.textContent = 'Select your size';
        } else {
          b.removeAttribute('disabled');
          b.classList.remove('size-gate-look-disabled');
          if (ls && b.__origLabel != null) ls.textContent = b.__origLabel;
        }
      });
      dynamicWraps.forEach(function (w) { w.style.display = on ? 'none' : ''; });
      if (stickyOptions && on) stickyOptions.textContent = '';
    }

    radios.forEach(function (r) { r.checked = false; });
    setGated(true);

    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) setGated(false); });
    });

    stickyBtn.forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (form.__sizeGated) {
          e.preventDefault();
          e.stopImmediatePropagation();
          scrollToPicker();
        }
      }, true);
    });

    // Backstop: block a submit (e.g. Enter) while still gated.
    form.addEventListener('submit', function (e) {
      if (form.__sizeGated) {
        e.preventDefault();
        e.stopImmediatePropagation();
        scrollToPicker();
      }
    }, true);
  }

  function init() {
    const form = document.querySelector('#MainContent form[is="product-form"]') ||
      document.querySelector('main form[is="product-form"]');
    gate(form);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
